<template>
    <div id="wallet">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="section-heading heading-left">
                    <span class="subtitle primary bold">Estatus.</span>
                    <div class="row">
                        <div class="col-lg-12 mb--20">
                            <h3 class="font-weight-100">
                                El <span class="bold">Modelo 3</span> asigna una calificación cuantitativa a cada crédito.
                                Los resultados de cobranza han sido congruentes
                                con el riesgo determinado.
                            </h3>
                            <h5 class="bold">Conoce más de la metodología <router-link :to="{name: 'calificacion'}" class="rg-a">aquí.</router-link></h5>
                        </div>
                    </div>
                    <div v-if="isMounted" class="row">
                        <!-- A -->
                        <div id="chart_A" class="col-sm-12 col-md-12 col-lg-8">
                            <VueApexCharts v-if="isGraphReady" type="bar" width="720" :options="chartOptions" :series="series"></VueApexCharts>
                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-4">
                            <p>
                                <span class="bold">Variables analizadas</span>
                                <br> >60
                                <br><span class="bold">Indicadores de evaluación</span>
                                <br> 42
                                <br><span class="bold">Parametrización</span>
                                <br> 100%
                                <br>
                                <br>
                                Para conocer más a detalle
                                sobre estas variables da clic <router-link :to="{name: 'calificacion'}" class="rg-a">aquí.</router-link>
                            </p>

                            <div class="display-flex">
                                <div class="marker bg-primary"></div>
                                <span class="bold">Al corriente</span>
                            </div>
                            <div class="display-flex">
                                <div class="marker bg-accent1"></div>
                                <span class="bold">Retrasado</span>
                            </div>
                            <div class="display-flex">
                                <div class="marker bg-black"></div>
                                <span class="bold">Vencido</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper.js";
import VueApexCharts from 'vue-apexcharts';
export default {
    name: "WalletStatus",
    props: ["rgStats", "isMounted"],
    mixins: [
        formatHelper
    ],
    components: {
        VueApexCharts
    },
    data: () => ({
        isGraphReady: false,
        publicSiteDuePortfolio: null,
        series: [{
            name: 'Al corriente',
            data: [0,0,0,0]
        }, {
            name: 'Retrasado',
            data: [0,0,0,0]
        }, {
            name: 'Vencido',
            data: [0,0,0,0]
        }],
        chartOptions: {
            chart: {
                type: 'bar',
                height: 720,
                zoom: {
                    enabled: true,
                    type: 'x',
                }
            },
            colors: ["#28DE18", "#CBFF00", "#3B3A3E"],
            responsive: [{
                breakpoint: 480,
                options: {
                    plotOptions: {
                        bar: {
                            horizontal: true
                        }
                    }
                }
            }],
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '75%',
                    endingShape: 'rounded'
                },
            },
            dataLabels: {
                enabled: false
            },
            legend: {
                show: false,
                position: 'right',
                offsetY: 40
            },
            stroke: {
                show: true,
                width: .5,
                colors: ['transparent']
            },
            xaxis: {
                categories: ['Grupo A', 'Grupo B', 'Grupo C', 'Grupo D', 'Grupo E',],
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        return `${val}%`
                    }
                }
            },
            fill: {
                opacity: 1
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return `${val}%`
                    }
                }
            }
        },
    }),
    mounted() {
        this.getStats();
    },
    methods: {
        getStats() {
            if(this.isMounted){
                const rg_stats = this.rgStats;
                this.publicSiteDuePortfolio = JSON.parse(rg_stats.public_site_due_portfolio);
                let index = 0;
                this.publicSiteDuePortfolio.duePortfolioStatus.forEach(element => {
                    if(index < 4) {
                        this.series[0].data[index] = ((element["Al corriente"] * 100)).toFixed(0);
                        this.series[1].data[index] = ((element["Retrasado"] * 100)).toFixed(0);
                        this.series[2].data[index] = ((element["Vencido"] * 100)).toFixed(0);
                        index++;
                    }
                });
                this.isGraphReady = true;
            }
        },
    }
}
</script>

<style>
.btn-outline-primary {
    border-radius: 20px;
    width: 85%;
}

.btn-outline-primary:hover {
    color: var(--color-black);
}

#myTabContent {
    text-align: -webkit-center;
    text-align: center;
}

#chart_A {
    text-align: -webkit-center;
}

.data-card {
    padding: 0.7rem 0rem 0.7rem 0rem;
    margin-top: -21px;
}

.primary-card {
    border: solid var(--color-primary);
    background-color: var(--color-primary);
}

.accent1-card {
    border: solid var(--color-accent1);
    background-color: var(--color-accent1);
}

.gray-card {
    border: solid var(--color-gray-5);
    background-color: var(--color-gray-5);
}

.black-card {
    border: solid var(--color-black);
    background-color: var(--color-black);
    color: var(--color-white);
}

.marker {
    width: 1rem;
    height: 1rem;
    /* background-color: aquamarine; */
    margin-right: 0.5rem;
    border-radius: 25px;
    margin-top: 0.2rem;
}

@media (max-width: 767px)
{
    #chart_A {
        overflow-y: scroll !important;
    }
}
</style>